// Generated by ReScript, PLEASE EDIT WITH CARE


function getColor(category, prefix) {
  switch (category) {
    case /* CustomerService */0 :
        return prefix + "__green-icon";
    case /* LoginActivity */1 :
        return prefix + "__red-icon";
    case /* OrderFulfillment */2 :
        return prefix + "__violet-icon";
    
  }
}

export {
  getColor ,
  
}
/* No side effect */
